export const KeyCodes = {
    comma: 188,
    enter: 13,
};

export const CLOSE_BUTTON_THEME_DARK="dark"
export const CLOSE_BUTTON_THEME_LIGHT="light"

export const PAGINATE_NEXT = "PAGINATE_NEXT"
export const PAGINATE_BACK = "PAGINATE_BACK"